import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    CircularProgress,
    Box,
} from "@mui/material";
import LearnerSubmittedModal from "./LearnerSubmitedModal";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#7e7e7e",
        color: theme.palette.common.white,
        textTransform: "capitalize",
        fontSize: 16,
        fontWeight: 600,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        textTransform: "capitalize",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd),&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const MentorPracticeTable = ({
    data=[],
    loading,
    selection
}) => {
    const safeData = Array.isArray(data) ? data : [];
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [open, setOpen] = useState(false);
    const [selected, setselected] = useState();
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const paginatedRows = safeData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const handleClick = (row) => {
        setOpen(true)
        setselected({...row,...selection})
    }

    return (
        <TableContainer component={Paper} className="table-container" sx={{ width: "100%", overflowX: "auto" }}>
            <Table sx={{ tableLayout: "auto", width: "max-content", minWidth: "100%" }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Maker Plan</StyledTableCell>
                        <StyledTableCell>Module</StyledTableCell>
                        <StyledTableCell>Topic</StyledTableCell>
                        <StyledTableCell>Type</StyledTableCell>
                        <StyledTableCell>Day</StyledTableCell>
                        <StyledTableCell>Coding Speed</StyledTableCell>
                        <StyledTableCell>#Learner Started</StyledTableCell>
                        <StyledTableCell>#Learner Submitted</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading ? (
                        <TableRow>
                            <StyledTableCell colSpan={7} align="center">
                                <Box display="flex" justifyContent="center" alignItems="center" height="30px">
                                    <CircularProgress />
                                </Box>
                            </StyledTableCell>
                        </TableRow>
                    ) : paginatedRows?.length > 0 ? (
                        paginatedRows.map((row, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell>{row?.makerplan_Name || "-"}</StyledTableCell>
                                <StyledTableCell>{row?.module_name || "-"}</StyledTableCell>
                                <StyledTableCell>{row?.topic_Name || "-"}</StyledTableCell>
                                <StyledTableCell>{row?.coding_type || 0}</StyledTableCell>
                                <StyledTableCell>{row?.daily_practice_name || "-"}</StyledTableCell>
                                <StyledTableCell>{row?.coding_speed || 0}</StyledTableCell>
                                <StyledTableCell>{row?.total_learners_started || 0}</StyledTableCell>
                                <StyledTableCell
                                    onClick={() => handleClick(row)}
                                    style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                >{row?.total_learners_submitted || 0}</StyledTableCell>

                            </StyledTableRow>
                        ))
                    ) : (
                        <StyledTableRow>
                            <StyledTableCell sx={{ fontWeight: "600", color: "grey" }} colSpan={9} align="center">
                                No Daily Practice records found.
                            </StyledTableCell>
                        </StyledTableRow>
                    )
                    }
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[10,20,30,60,100]}
                component="div"
                count={data?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <LearnerSubmittedModal
                open={open}
                onClose={() => setOpen(false)}
                selected={selected}
            />

        </TableContainer>
    );
};
export default MentorPracticeTable;
